import { api } from "./baseApi";

export interface CustomTool {
	id: string;
	slug: string;
	name: string;
	description: string;
	icon: string;
	isActive: boolean;
	isCustom: boolean;
	department: string;
	ownerId: string;
	s3Prefix: string;
	createdAt: string;
	updatedAt: string;
	ownerName?: string;
}

export const customToolApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getCustomTools: builder.query<{ tools: CustomTool[] }, void>({
			query: () => "/custom-tools",
			providesTags: ["CustomTool"]
		}),
		getMyCustomTools: builder.query<{ tools: CustomTool[] }, void>({
			query: () => "/custom-tools/my-tools",
			providesTags: ["CustomTool"]
		}),
		createCustomTool: builder.mutation<CustomTool, FormData>({
			query: (formData) => ({
				url: "/custom-tools",
				method: "POST",
				body: formData
			}),
			invalidatesTags: ["CustomTool"]
		}),
		updateCustomTool: builder.mutation<CustomTool, { id: string; formData: FormData }>({
			query: ({ id, formData }) => ({
				url: `/custom-tools/${id}`,
				method: "PUT",
				body: formData
			}),
			invalidatesTags: ["CustomTool"]
		}),
		deleteCustomTool: builder.mutation<{ success: boolean }, string>({
			query: (id) => ({
				url: `/custom-tools/${id}`,
				method: "DELETE"
			}),
			invalidatesTags: ["CustomTool"]
		}),
		getCustomToolFile: builder.query<{ url: string }, { id: string; filename: string }>({
			query: ({ id, filename }) => `/custom-tools/${id}/serve/${filename}`
		})
	})
});

export const {
	useGetCustomToolsQuery,
	useGetMyCustomToolsQuery,
	useCreateCustomToolMutation,
	useUpdateCustomToolMutation,
	useDeleteCustomToolMutation,
	useLazyGetCustomToolFileQuery
} = customToolApi;
